import { IconTools } from '@tabler/icons-react'

type Props = { title: string; description?: string; icon?: React.ReactNode }

export function PlaceholderPage({ title, description, icon }: Props) {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-96 text-center px-6">
      <div className="w-14 h-14 rounded-2xl bg-surface-raised border border-border-default flex items-center justify-center mb-4">
        {icon ?? <IconTools size={22} className="text-zinc-600" />}
      </div>
      <h2 className="text-base font-medium text-zinc-300 mb-2">{title}</h2>
      {description && <p className="text-sm text-zinc-600 max-w-xs leading-relaxed">{description}</p>}
    </div>
  )
}
